<template>
	<div>
		<form class="send-reset-form" @submit.prevent="submitForm">
			<div class="form-group">
				<label for="username">Email</label>
				<input
					type="email"
					class="form-control"
					name="username"
					placeholder="E-mail Address"
					v-model="email"
					required
					:class="{ 'is-invalid': isInvalidEmail }"
				/>
			</div>
			<div class="form-group mt-4">
				<button class="btn btn-primary w-100" type="submit">
					<span
						v-if="loading"
						class="spinner-border spinner-border-sm mr-2"
						role="status"
						aria-hidden="true"
					></span>
					Send Reset Password Link
				</button>
			</div>
			<div class="form-group">
				<router-link
					class="btn btn-secondary"
					:to="{ path: '/console/login' }"
					>Back to Login</router-link
				>
				<ErrorDialog ref="errDialog" />
			</div>
		</form>
	</div>
</template>

<script>
import ErrorDialog from "../shared/ErrorDialog";
import Register from "../../services/register";

export default {
	name: "SendResetForm",
	components: {
		ErrorDialog,
	},
	data() {
		return {
			email: "",
			isInvalidEmail: false,
			loading: false,
		};
	},
	methods: {
		submitForm() {
			this.loading = true;
			Register.instance()
				.resetRequest(this.email)
				.then(() => {
					this.$router.push({
						path: "/reset/prompt",
						query: { email: this.email },
					});
					this.loading = false;
				})
				.catch((err) => {
					this.$refs.errDialog(err);
					this.loading = false;
				});
		},
	},
};
</script>